export default __webpack_public_path__ + "static/media/trending-down.bf897469.svg";